'use strict';

angular.module('shiftTraderApp')
  .factory('PhoneResource', function ($resource, ServerUrls) {

    var apiBase = ServerUrls.current.railsApi + 'users/:user_id/phone_numbers/:id';

    if (_.contains(apiBase, ':')) {
      apiBase = apiBase.replace(':', '\\:');
    }

    var actions = {
      setPrimary: {
        method:'PUT'
      }
    };

    var params = {
      'id':'@id',
      'user_id':'@user_id'
    };

    var PhoneNumber = $resource(apiBase, params, actions);
    PhoneNumber.prototype.formattedNumber = function() {
      var temp = this.number.replace(/[^0-9]/g,'');
      return temp.replace(/[1]?(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    };

    return PhoneNumber;
  });
